import { CheckCircle2Icon } from "lucide-react";
import { Button } from "~/components/ui/button";
import { RESPONSIVE_TEXT_BUTTON_CLASS } from "~/lib/touchTarget";

export function ProjectLeadCommittedState(props: {
  readonly taskIds: readonly number[];
  readonly onClose: () => void;
}) {
  return (
    <div className="grid flex-1 place-items-center p-8 text-center">
      <div className="max-w-md space-y-3">
        <CheckCircle2Icon className="mx-auto size-10 text-success" aria-hidden />
        <h3 className="text-lg font-semibold">Task tree created</h3>
        <p className="text-sm text-muted-foreground">
          Forge created {props.taskIds.length} linked tasks in one atomic operation.
        </p>
        <Button className={RESPONSIVE_TEXT_BUTTON_CLASS} onClick={props.onClose}>
          Return to board
        </Button>
      </div>
    </div>
  );
}
